import { runtimeMonitor, type RuntimeTask } from '@w/runtime'
import type { Tel } from '@w/tel'

/** Owns the client boot trace and runtime task. */
export function runFlashcardsStartup<T>(
  tel: Tel,
  name: string,
  fn: (startupTel: Tel, task: RuntimeTask) => Promise<T>,
): Promise<T> {
  const box: { context?: T } = {}
  return tel
    .span({ name: 'app.startup', input: undefined }, async startupTel => {
      box.context = await runtimeMonitor.run({ name, kind: 'startup' }, task => fn(startupTel, task))
    })
    .catch(error => {
      tel.error(error, { operation: 'app.startup' })
      throw error
    })
    .then(() => box.context as T)
}
